<template>
    <div class="administradores">
        <h2 class="subheading grey--text">{{$t('Administradores')}}</h2>
        <v-container class="my-5">
            <v-dialog
                    v-model="dialogElimnar"
                    max-width="400"
            >
                <v-card>
                    <v-card-title class="headline">
                        {{$t('msg_eliminar_administrador')}}
                    </v-card-title>
                    <v-card-text>
                        {{$t('msg_eliminar_invitacion_2')}}
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialogElimnar = false"
                            >
                                No
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    color="primary"
                                    @click="deleteAdministrador()"
                            >
                                {{$t('Si')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_move_up"
                    max-width="600"
            >
                <v-card class="elevation-5">
                    <v-toolbar class="mb-5" dark color="primary">
                        <v-toolbar-title>
                            {{$t('move_up')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_move_up = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-form class="mb-4"
                                @submit.prevent="change_user_to_employee()">
                            <v-layout row wrap>
                                <v-autocomplete
                                        v-model="email2"
                                        :items="items"
                                        prepend-icon="email"
                                        :loading="isLoading"
                                        :search-input.sync="search2"
                                        item-text="email"
                                        item-value="id"
                                        :placeholder="$t('placeholder_invitados')"
                                        :label="$t('usuarios')"
                                        :error-messages="errores.guest ? errores.guest.email : ''"
                                        :no-data-text="$t('no_resultados')"
                                        clearable
                                >
                                    <template v-slot:selection="data">
                                        <v-chip
                                                :selected="data.selected"
                                                class="chip--select-multi"
                                        >
                                            {{ data.item.email }} - {{ data.item.celular }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                        {{ data.item.email }} - {{ data.item.celular }}, {{data.item.first_name}} {{data.item.last_name}}
                                    </template>
                                </v-autocomplete>
                            </v-layout>
                            <v-layout row wrap>
                                <v-autocomplete
                                        v-model="idParque2"
                                        prepend-icon="location_city"
                                        name="idParque2"
                                        item-text="nombre"
                                        item-value="id"
                                        :label="$t('Area')"
                                        :filter="customFilter"
                                        :error-messages="errores.error"
                                        :items="parques"
                                        :no-data-text="$t('no_resultados')"
                                        clearable
                                ></v-autocomplete>
                            </v-layout>
                            <v-btn
                                    color="primary"
                                    @click="dialog_move_up = false"
                            >
                                {{$t('cerrar')}}
                            </v-btn>

                            <v-btn
                                    color="primary"
                                    @click="change_user_to_employee()"
                            >
                                {{$t('modificar')}}
                                <v-icon dark right>arrow_upward</v-icon>
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
            <v-dialog v-model="dialogCellNumberWrong" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                    <v-card-text>
                        <br>
                        {{$t('cellphone_wrong')}}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialogCellNumberWrong = false, dialog = true">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
            <v-dialog v-model="dialog_img_frontal" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                ref="clipper"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneFrenteURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        class="justify-center"
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        class="justify-center mr-3"
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="get_image_recortada()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
            <v-dialog v-model="dialog_img_atras" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                ref="clipper2"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneAtrasURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        class="justify-center"
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        class="justify-center mr-3"
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="dialog_img_atras = false, get_image_recortada_atras()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
            <v-dialog v-model="dialog_img_perfil" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                class="basic lg"
                                :src="imagePerfilURL"
                                ref="clipper3"
                                :rotate="degrees"
                                :round="true"
                                preview="preview">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-slider
                                        class="justify-center mr-3"
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="get_image_recortada_perfil()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-dialog v-model="dialog" scrollable persistent max-width="600px">
                    <template v-slot:activator="{ on }">
                        <v-btn
                                color="primary"
                                dark
                                v-on="on"
                                @click="update = false,
                                clean_fields()"> + {{$t('anadir_administrador')}}
                        </v-btn>
                        <v-btn
                                v-if="getProfile.roll === 5"
                                arrow_upward
                                color="primary"
                                @click="dialog_move_up = true,
                                clean_fields_move_up()"
                        >
                            <v-icon dark left>swap_horiz</v-icon>
                            {{$t('cambiar_permisos')}}
                        </v-btn>
                    </template>
                    <v-form
                            @submit.prevent="update
                                        ? updateAdministrador(id_update)
                                        : altaAdministrador()">
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{$t('Administradores')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-autocomplete
                                                class="pt-3 pb-3"
                                                v-model="idParque"
                                                prepend-icon="location_city"
                                                name="idParque"
                                                item-text="nombre"
                                                item-value="id"
                                                :label="$t('Parques')"
                                                :filter="customFilter"
                                                :error-messages="errores.park"
                                                :items="parques"
                                                :no-data-text="$t('no_resultados')"
                                                clearable
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                class="pt-3 pb-3"
                                                v-model="first_name"
                                                prepend-icon="person"
                                                name="first_name"
                                                :label="$t('Nombre')"
                                                :error-messages="errores_seg.first_name"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                class="pt-3 pb-3"
                                                v-model="last_name"
                                                prepend-icon="person_outline"
                                                name="last_name"
                                                :label="$t('Apellido')"
                                                :error-messages="errores_seg.last_name"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                class="pt-3 pb-3"
                                                v-model="email"
                                                prepend-icon="email"
                                                name="email"
                                                label="E-Mail"
                                                :error-messages="errores_seg.email"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap
                                          v-if="getProfile.roll == 5"
                                >
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                class="pt-3 pb-3"
                                                v-model="extension"
                                                prepend-icon="phone_iphone"
                                                name="extension"
                                                :label="$t('extension')"
                                                :error-messages="errores.extension"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-checkbox
                                                class="pt-3 pb-3"
                                                v-model="puede_enviar"
                                                name="puede_enviar"
                                                :label="$t('puede_enviar')"
                                                :error-messages="errores.puede_enviar"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="text-sm-center">
                                    <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                        <v-label>
                                            {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                        </v-label>
                                        <br>
                                        <v-img
                                                class="pt-3 pb-3"
                                                :src="resultIneFrenteURL"
                                                v-if="resultIneFrenteURL"
                                                width="auto"
                                                height="180"
                                        ></v-img>
                                        <br>
                                        <v-alert
                                                :value="errores_seg.ine_frente"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.ine_frente}}
                                        </v-alert>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialog_img_frontal = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imageIneFrenteURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                        <v-label>
                                            {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                        </v-label>
                                        <br>
                                        <v-img
                                                class="pt-3 pb-3"
                                                :src="resultIneAtrasURL"
                                                v-if="resultIneAtrasURL"
                                                width="auto"
                                                height="180"
                                        ></v-img>
                                        <br>
                                        <v-alert
                                                :value="errores_seg.ine_atras"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.ine_atras}}
                                        </v-alert>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialog_img_atras = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imageIneAtrasURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="text-sm-center">
                                    <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                        <v-label>
                                            {{$t('foto_perfil')}}
                                        </v-label>
                                        <br>
                                        <v-img
                                                class="pt-3 pb-3"
                                                :src="resultPerfilURL"
                                                v-if="resultPerfilURL"
                                                width="auto"
                                                height="180"
                                        ></v-img>
                                        <br>
                                        <v-alert
                                                :value="errores_seg.avatar"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.avatar}}
                                        </v-alert>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialog_img_perfil = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imagePerfilURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                <v-flex sm6 class="mr-3 ml-3">
                                    {{$t('celular')}}
                                    <vue-tel-input
                                            class="mt-3 mb-3"
                                            v-model="celular"
                                            @onInput="onInput"
                                    ></vue-tel-input>
<!--                                    <v-alert v-if="errores_seg.celular" type="error">{{errores_seg.celular}}</v-alert>-->
                                    <v-alert
                                        :value="errores_seg.celular"
                                        color="error"
                                        icon="warning"
                                        outline
                                    >
                                    {{errores_seg.celular}}
                                    </v-alert>
                                </v-flex>
<!--                                    <v-flex xs12 sm6>-->
<!--                                        <v-checkbox-->
<!--                                                class="pt-3 pb-3"-->
<!--                                                v-model="activa"-->
<!--                                                v-if="update" disable-->
<!--                                                name="activa"-->
<!--                                                :label="$t('Activo')"-->
<!--                                                :error-messages="errores.activa"-->
<!--                                        ></v-checkbox>-->
<!--                                    </v-flex>-->
                                </v-layout>
                                <v-checkbox
                                        v-model="change_password"
                                        v-if="update" disable
                                        name="change_password"
                                        label="Cambiar Contraseña"
                                ></v-checkbox>
                                <v-text-field
                                        class="pt-3 pb-3"
                                        v-model="password"
                                        :disabled="update && !change_password ? true: false"
                                        name="password"
                                        prepend-icon="lock"
                                        :label="$t('password')"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'visibility' : 'visibility_off'"
                                        :error-messages="errores_seg.password"
                                        data-vv-name="password"
                                        ref="password"
                                        @click:append="show = !show">
                                </v-text-field>
                                <v-text-field
                                        class="pt-3 pb-3"
                                        v-validate="change_password ? 'required|confirmed:password': ''"
                                        v-model="confirm_password"
                                        :disabled="update  && !change_password ? true: false"
                                        name="confirm_password"
                                        prepend-icon="lock"
                                        :label="$t('password_confirm')"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'visibility' : 'visibility_off'"
                                        :error-messages="errors.collect('confirm_password')"
                                        @click:append="show = !show"
                                        data-vv-name="confirm_password">
                                </v-text-field>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary"
                                       @click="clear(),
                                           dialog = false"
                                >{{ $t('cerrar') }}
                                </v-btn>
                                <v-spacer/>
                                <v-btn
                                        v-if="update"
                                        :loading="loading"
                                        color="primary"
                                        type="submit"
                                >{{ $t('modificar') }}
                                </v-btn>
                                <v-btn
                                        v-else
                                        :loading="loading"
                                        color="primary"
                                        type="submit"
                                >{{ $t('agregar') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('Administradores')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_administradores"
                            :items="administradores"
                            :search="search"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
<!--                            <td class="justify-center layout px-0">-->
<!--                                <v-icon-->
<!--                                        medium-->
<!--                                        @click="fill_fields(props.item),-->
<!--                                        update = true,-->
<!--                                        dialog = true,-->
<!--                                        id_update = props.item.id"-->
<!--                                >-->
<!--                                    edit-->
<!--                                </v-icon>-->
<!--                            </td>-->
<!--                            <td align="center">-->
<!--                                <v-icon-->
<!--                                        medium-->
<!--                                        color="red"-->
<!--                                        @click="dialogElimnar = true, idAdministradorEliminar = props.item.id"-->
<!--                                >-->
<!--                                    delete-->
<!--                                </v-icon>-->
<!--                            </td>-->
                            <td align="center">
                                <v-icon
                                        medium
                                        class="mr-2"
                                        @click="fill_fields(props.item),
                                        update = true,
                                        dialog = true,
                                        id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                                <v-icon
                                        medium
                                        color="red"
                                        @click="dialogElimnar = true, idAdministradorEliminar = props.item.id"
                                >
                                    delete
                                </v-icon>
                            </td>
                            <!--                            <td>{{ props.item.id }}</td>-->
                            <td>{{ props.item.user.first_name }}</td>
                            <td>{{ props.item.user.last_name }}</td>
                            <td>{{ props.item.user.celular }}</td>
                            <td>{{ props.item.user.email }}</td>
<!--                            <td>{{ props.item.user.is_active ? $t('Si') : "No" }}</td>-->
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Administradores')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import { Validator } from 'vee-validate'
    import VuejsClipper from 'vuejs-clipper'
    import { mapState, mapGetters} from 'vuex'
    import ClipperFixed from "vuejs-clipper/src/components/clipper-fixed";

    Vue.use(VeeValidate)
    Vue.use(VuejsClipper ,{
        components: {
            clipperBasic: 'clipper-basic',
            clipperFixed: 'clipper-fixed',
            clipperUpload: 'clipper-upload'
        }
    })

    const dictionary = {
        en: {
            messages:{
                confirmed: () => 'The passwords didn\'t match',
                required: () => 'This field is required'
            }
        },
        es: {
            messages: {
                confirmed: () => 'Las contraseñas no coinciden',
                required: () => 'Este campo es requerido'
            }
        }
    };
    Validator.localize(dictionary);
    const validator = new Validator({ confirm_password: 'confirmed' });
    // Falta investigar como cambiar el idioma de los mensajes
    // con vue-validate
    // validator.localize(this.$store.state.language);
    validator.localize('es');

    export default {
        name: "administradores_parque",
        components: {ClipperFixed},
        created: function(){
            this.getAdministradores()
            this.getParques()
            // this.get_extra_data()
        },
        beforeUpdate() {
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    value: 'name',
                    sortable: false
                },
                // {
                //     text: 'ID',
                //     align: 'left',
                //     sortable: true,
                //     value: 'id'
                // },
                {
                    text: this.$t('Nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'user.first_name'
                },
                {
                    text: this.$t('Apellido'),
                    align: 'left',
                    sortable: true,
                    value: 'user.last_name'
                },
                {
                    text: this.$t('celular'),
                    align: 'left',
                    sortable: true,
                    value: 'user.celular'
                },
                {
                    text: 'E-Mail',
                    align: 'left',
                    sortable: true,
                    value: 'user.email'
                },
                // {
                //     text: this.$t('Activo'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'user.is_active'
                // },
                // {
                //     text: this.$t('puede_enviar'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'user.puede_enviar'
                // }
            ]
        },
        data () {
            return{
                rules: {
                    required: value => !!value || 'Campo Requerido',
                    counter: value => value.length >= 10 || 'El Número de Celular debe de contener 10 dígitos',
                    number: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Ingresa un Campo Númerico.'
                    },
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Dirección E-Mail no Válida.'
                    },
                },
                show: false,
                alerta: false,
                administradores: [],
                parques: [],
                dialog: false,
                update:false,
                id_update: 0,
                idParque: '',
                first_name: '',
                last_name: '',
                extension: '',
                puede_enviar: false,
                celular:'',
                email: '',
                password: '',
                confirm_password: '',
                errores: [],
                errores_seg: [],
                ine_frente_imageName: '',
                ine_frente_imageUrl: '',
                ine_frente_imageFile: '',
                ine_atras_imageName: '',
                ine_atras_imageUrl: '',
                ine_atras_imageFile: '',
                activa: '',
                headers: [],
                search: '',
                loading_data_administradores: false,
                change_password: '',
                dialogElimnar: false,
                idAdministradorEliminar: '',
                dialog_move_up: false,
                email2: 0,
                search2: null,
                entries: [],
                isLoading: false,
                idParque2: 0,
                dialog_img_frontal: false,
                dialog_img_atras: false,
                dialog_img_perfil: false,
                // Variables imagen recortada
                imageIneFrenteURL: '',
                imageIneAtrasURL: '',
                imagePerfilURL: '',
                resultIneFrenteURL: '',
                resultIneAtrasURL: '',
                resultPerfilURL: '',
                resultAuxIneFrenteURL: '',
                resultAuxIneAtrasURL: '',
                resultAuxPerfilURL: '',
                dialogCellNumberWrong: false,
                band_cellphone: true,
                loading: false,
                emailAux: '',
                celularAux: '',
                degrees: 0,
                ratio: 1
            }
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile']),
            fields () {
                if (!this.email2) return []

                return Object.keys(this.email2).map(key => {
                    return {
                        key,
                        value: this.email2[key] || 'n/a'
                    }
                })
            },
            items () {
                return this.entries.map(entry => {
                    const email = entry.email.length > this.descriptionLimit
                        ? entry.email.slice(0, this.descriptionLimit) + '...'
                        : entry.email

                    return Object.assign({}, entry, { email })
                })
            }
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search2 (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if (val.length > 2){

                    this.isLoading = true

                    // Lazily load input items
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/simpleUser/filter?search=' + val,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log(response.data)
                            if(this.entries.length > 0){
                                for(var i =0 ; i < response.data.length; i++){
                                    this.entries.push(response.data[i])
                                }
                            }
                            else
                                this.entries = response.data
                        })
                        .catch(error => {
                            console.log(error)
                        })
                        .finally(() => (this.isLoading = false))
                }
            }
        },
        methods:{
            getAdministradores () {
                this.loading_data_administradores = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/AdminPark/ListCreate',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.administradores = response.data
                        this.loading_data_administradores = false
                    })
                    .catch(error => {
                        this.loading_data_administradores = false
                        console.log(error)
                    })

            },
            getParques () {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/parques/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        this.parques = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_extra_data: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/administradores/user/' + this.getProfile.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data[0].id_empresa
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            altaAdministrador: function () {
                console.log(this.ine_frente_imageFile)
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.band_cellphone === true) {
                            this.loading = true
                            if ( this.idParque === undefined) {
                                this.idParque = ''
                            }
                            this.errores = []
                            this.errores_seg = []
                            var bodyFormData = new FormData()
                            var file = null
                            var file2 = null
                            var file3 = null

                            bodyFormData.set('user.first_name', this.first_name)
                            bodyFormData.set('user.last_name', this.last_name)
                            bodyFormData.set('user.celular', this.celular)
                            bodyFormData.set('user.username', this.celular)
                            bodyFormData.set('user.email', this.email.toLowerCase())
                            bodyFormData.set('user.password', this.password)
                            bodyFormData.set('park', this.idParque)
                            if (this.resultIneFrenteURL != '' && this.resultIneFrenteURL.length > 6) {
                                file = this.dataURLtoFile(this.resultIneFrenteURL, 'ine_front.jpeg')
                            }
                            bodyFormData.append('user.ine_frente', file)
                            if (this.resultIneAtrasURL != '' && this.resultIneAtrasURL.length > 6) {
                                file2 = this.dataURLtoFile(this.resultIneAtrasURL, 'ine_back.jpeg')
                            }
                            bodyFormData.append('user.ine_atras', file2)
                            if (this.resultPerfilURL != '' && this.resultPerfilURL.length > 6) {
                                file3 = this.dataURLtoFile(this.resultPerfilURL, 'avatar.jpeg')
                            }
                            bodyFormData.append('user.avatar', file3)
                            const config = {
                                method: 'post',
                                url: 'https://empresa-service.intrare.app/AdminPark/ListCreate/',
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    'Accept-Language': this.language ,
                                    'authorization': 'Token ' + store.getters.getToken
                                },
                                data: bodyFormData
                            };
                            axios(config)
                                .then(ok => {
                                    this.loading = false
                                    this.getAdministradores()
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_message', this.$t('mensaje_administrador_alta'))
                                    this.dialog = false
                                    setTimeout(this.clear, 3000);
                                })
                                .catch(error => {
                                    this.loading = false
                                    if(error.response.status == 400
                                        && typeof error.response.data == "object"
                                        && error.response.data) {
                                        if(error.response.data)
                                            this.errores = error.response.data
                                        if(error.response.data.user)
                                            this.errores_seg = error.response.data.user
                                    }
                                })

                        } else {
                            this.dialog = false
                            this.dialogCellNumberWrong = true
                        }
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            updateAdministrador: function (id) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.band_cellphone === true) {
                            this.loading = true
                            var bodyFormData = new FormData()
                            var file = null
                            var file2 = null
                            var file3 = null

                            if (this.idParque === undefined) {
                                this.idParque = ''
                            }
                            this.errores = []
                            this.errores_seg = []
                            if (this.emailAux !== this.email) {
                                // idUser['email'] = this.email.toLowerCase()
                                bodyFormData.set('user.email', this.email.toLowerCase())
                            }
                            if (this.celularAux !== this.celular) {
                                bodyFormData.set('user.celular', this.celular)
                                bodyFormData.set('user.username', this.celular)
                                // idUser['cellNumber'] = this.celular
                            }
                            if (this.change_password === true) {
                                bodyFormData.set('user.password', this.password)
                                // idUser['password'] = this.password
                            }
                            bodyFormData.set('user.first_name', this.first_name)
                            bodyFormData.set('user.last_name', this.last_name)

                            if( this. resultAuxIneFrenteURL !== this.resultIneFrenteURL) {
                                if (this.resultIneFrenteURL != '' && this.resultIneFrenteURL.length > 6) {
                                    file = this.dataURLtoFile(this.resultIneFrenteURL, 'ine_front_update.jpeg')
                                }
                                bodyFormData.append('user.ine_frente', file)
                            }
                            if( this. resultAuxIneAtrasURL !== this.resultIneAtrasURL) {
                                if (this.resultIneAtrasURL != '' && this.resultIneAtrasURL.length > 6) {
                                    file2 = this.dataURLtoFile(this.resultIneAtrasURL, 'ine_back_update.jpeg')
                                }
                                bodyFormData.append('user.ine_atras', file2)
                            }
                            if( this. resultAuxPerfilURL !== this.resultPerfilURL) {
                                if (this.resultPerfilURL != '' && this.resultPerfilURL.length > 6) {
                                    file3 = this.dataURLtoFile(this.resultPerfilURL, 'avatar_update.jpeg')
                                }
                                bodyFormData.append('user.avatar', file3)
                            }
                            bodyFormData.set('park', this.idParque)
                            const config = {
                                method: 'patch',
                                url: 'https://empresa-service.intrare.app/AdminPark/UpdateDetail&Delete/'+ id +'/',
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    'Accept-Language': this.language ,
                                    'authorization': 'Token ' + store.getters.getToken
                                },
                                data: bodyFormData
                            };
                            axios(config)
                                .then(ok => {
                                    this.loading = false
                                    this.getAdministradores()
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_message', this.$t('mensaje_administrador_modificado'))
                                    this.dialog = false
                                    setTimeout(this.clear, 3000);
                                })
                                .catch(error => {
                                    this.loading = false
                                    if(error.response.status == 400
                                        && typeof error.response.data == "object"
                                        && error.response.data){
                                        if(error.response.data)
                                            this.errores = error.response.data
                                        if(error.response.data.user)
                                            this.errores_seg = error.response.data.user
                                    }
                                })
                        } else {
                            this.dialog = false
                            this.dialogCellNumberWrong = true
                        }
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            deleteAdministrador(){
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/AdminPark/UpdateDetail&Delete/' + this.idAdministradorEliminar + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                };
                axios(config).then(ok => {
                    console.log('Empleado con ID_ADMINISTRADOR = ', this.idAdministradorEliminar + ' eliminado Correctamente.')
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', this.$t('mensaje_administrador_eliminado'))
                    this.getAdministradores()
                    setTimeout(this.clear, 3000);
                    this.dialogElimnar = false
                })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            change_user_to_employee(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'PATCH',
                            url: 'https://empresa-service.intrare.app/upgradeUserEmployee/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                idUsuario: this.email2,
                                idArea: this.idParque2,
                                extension: "0"
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.getAdministradores()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
                                this.dialog_move_up = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.errores_seg = []
                this.$validator.reset()
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields(item){
                this.first_name = item.user.first_name
                this.last_name = item.user.last_name
                this.celular = item.user.celular
                this.email = item.user.email
                this.celularAux = item.user.celular
                this.emailAux = item.user.email
                this.password = ''
                this.confirm_password = ''
                this.idParque = item.park
                this.ine_frente_imageName = ''
                this.ine_atras_imageName = ''
                this.resultIneFrenteURL = item.user.ine_frente
                // console.log(this.ine_frente_imageUrl)
                // this.ine_atras_imageName = ''
                // this.ine_atras_imageFile = item.user.ine_atras
                this.resultIneAtrasURL = item.user.ine_atras
                this.resultPerfilURL = item.user.avatar

                this.resultAuxIneFrenteURL = item.user.ine_frente
                this.resultAuxIneAtrasURL = item.user.ine_atras
                this.resultAuxPerfilURL = item.user.avatar
                this.change_password = false
                this.errores = []
                this.errores_seg = []
            },
            customFilter (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            clean_fields(){
                this.first_name = ''
                this.last_name = ''
                this.celular = ''
                this.email = ''
                this.celularAux = ''
                this.emailAux = ''
                this.password = ''
                this.extension = ''
                this.puede_enviar = false
                this.idParque = ''
                this.ine_frente_imageName = ''
                this.ine_frente_imageFile = ''
                this.resultIneFrenteURL = ''
                this.resultPerfilURL = ''
                this.ine_atras_imageName = ''
                this.ine_atras_imageFile = ''
                this.resultIneAtrasURL = ''
                this.change_password = true
                this.errores = []
                this.errores_seg = []
            },
            clean_fields_move_up(){
                this.email2 = 0
                this.idParque2 = 0
            },
            pickFile_ine_frente () {
                this.$refs.image_ine_frente.click ()
            },
            onFilePicked_ine_frente (e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.ine_frente_imageName = files[0].name
                    if(this.ine_frente_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.ine_frente_imageUrl = fr.result
                        this.ine_frente_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.ine_frente_imageName = ''
                    this.ine_frente_imageFile = ''
                    this.ine_frente_imageUrl = ''
                }
            },
            pickFile_ine_atras () {
                this.$refs.image_ine_atras.click ()
            },
            onFilePicked_ine_atras (e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.ine_atras_imageName = files[0].name
                    if(this.ine_atras_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.ine_atras_imageUrl = fr.result
                        this.ine_atras_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.ine_atras_imageName = ''
                    this.ine_atras_imageFile = ''
                    this.ine_atras_imageUrl = ''
                }
            },
            get_image_recortada() {
                console.log('Datos de la imagen = ', this.imageIneFrenteURL.size)
                const canvas = this.$refs.clipper.clip();//call component's clip method
                this.resultIneFrenteURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultIneFrenteURL)
                this.dialog_img_frontal = false
                this.dialog = true
            },
            get_image_recortada_atras() {
                const canvas = this.$refs.clipper2.clip();//call component's clip method
                this.resultIneAtrasURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultIneAtrasURL)
                this.dialog_img_atras = false
                this.dialog = true
            },
            get_image_recortada_perfil() {
                const canvas = this.$refs.clipper3.clip();//call component's clip method
                this.resultPerfilURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultPerfilURL)
                this.dialog_img_perfil = false
                this.dialog = true
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            onInput ({ number, isValid, country }) {
                console.log(number.e164)
                console.log(isValid)
                console.log(country)
                this.celular = number.e164
                this.band_cellphone = isValid
            }
        }
    }
</script>

<style scoped>
    .ingla {
        border-radius: 2px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 2px 2px 2px 2px;
        border-style: solid solid solid solid;
    }
</style>
